export const listWebFormByPromocode = /* GraphQL */ `
  query listWebFormByPromocode($input: String!, $nextToken: String) {
    listWebFormByPromocode(code: $input, nextToken: $nextToken) {
      scannedCount
      items {
        transactionId
      }
      nextToken
    }
  }
`;
